import { useEffect } from 'react';

interface Props {
  title: string;
  data: unknown;
  loading?: boolean;
  error?: string | null;
  onClose: () => void;
}

export function JsonViewer({ title, data, loading, error, onClose }: Props) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function copy() {
    await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--panel)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius)',
          maxWidth: 900,
          width: '100%',
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className="row between"
          style={{ padding: 16, borderBottom: '1px solid var(--border)' }}
        >
          <h3 style={{ margin: 0, fontFamily: 'ui-monospace, monospace', fontSize: 14 }}>
            {title}
          </h3>
          <div className="row">
            <button onClick={copy} disabled={loading || !!error}>
              Copiar
            </button>
            <button onClick={onClose}>Cerrar (Esc)</button>
          </div>
        </div>
        <div style={{ overflow: 'auto', padding: 16, flex: 1 }}>
          {loading && <p className="muted">Cargando…</p>}
          {error && <div className="error">{error}</div>}
          {!loading && !error && (
            <pre
              style={{
                margin: 0,
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                fontSize: 12,
                lineHeight: 1.6,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {JSON.stringify(data, null, 2)}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
}
